import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

window.$store = store;
window.Vue = Vue;

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast);

import "vue-multiselect/dist/vue-multiselect.min.css";
import "filepond/dist/filepond.min.css";
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

Vue.component('pagination', require('laravel-vue-pagination'));

//Code sử dụng notification
// this.$toast("Default toast");
// this.$toast.info("Info toast");
// this.$toast.success("Success toast");
// this.$toast.error("Error toast");
// this.$toast.warning("Warning toast");

function loggedIn() {
    return localStorage.getItem('token');
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.login == true)) {
        if (!loggedIn()) {
            Vue.$toast.warning('Vui lòng đăng nhập', {
                timeout: 3000,
            });
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        } else {
            next()
        }
    } else if(to.matched.some(record => record.meta.login == false)) {
        if(loggedIn()) {
            next({
                path: '/',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

Vue.config.productionTip = false;

require('@/config/axios');
require('@/config/prototype');

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
